import { render, staticRenderFns } from "./GiftGetPopup.vue?vue&type=template&id=6c1b91e3&scoped=true&"
import script from "./GiftGetPopup.vue?vue&type=script&lang=js&"
export * from "./GiftGetPopup.vue?vue&type=script&lang=js&"
import style0 from "./GiftGetPopup.vue?vue&type=style&index=0&id=6c1b91e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b91e3",
  null
  
)

component.options.__file = "GiftGetPopup.vue"
export default component.exports